import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOldnav = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 300,
	height: 180,
	viewBox: "0 0 300 180",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1893_18385)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 300,
					height: 180,
					rx: 10,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "path-3-inside-1_1893_18385",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M0 0H300V40H0V0Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0 0H300V40H0V0Z",
					fill: "#F0F9FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M300 40V39H0V40V41H300V40Z",
					fill: "#BCE1FA",
					mask: "url(#path-3-inside-1_1893_18385)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.3981 18.9744C18.7219 19.6193 19.7535 22.7043 19.7807 25.8072C19.7813 25.877 19.7251 25.934 19.6555 25.934H15.4715C15.4025 25.934 15.3463 25.8781 15.3459 25.8088C15.3334 23.4015 14.9444 21.2771 12.5654 21.1854C12.4944 21.1827 12.4352 21.2397 12.4352 21.311V25.8084C12.4352 25.8778 12.3792 25.934 12.31 25.934H8.12524C8.05609 25.934 8 25.8779 8 25.8084V14.3488C8 14.2794 8.05609 14.2232 8.12524 14.2232H12.31C12.3792 14.2232 12.4352 14.2794 12.4352 14.3488V18.6415C12.4352 18.7052 12.4867 18.7568 12.5502 18.7568C12.6006 18.7568 12.6454 18.724 12.66 18.6755C13.738 15.1356 15.7512 14.2454 19.0203 14.2236C19.0896 14.2231 19.1465 14.2796 19.1465 14.3491V18.6313C19.1465 18.7006 19.0904 18.7568 19.0212 18.7568H15.4191C15.3586 18.7568 15.3096 18.806 15.3096 18.8666C15.3096 18.9192 15.3468 18.9645 15.3981 18.9744ZM26.8546 21.6579V18.8824C26.8546 18.8131 26.9107 18.7568 26.9798 18.7568H30.0593C30.1199 18.7568 30.169 18.7076 30.169 18.6468C30.169 18.5941 30.1316 18.549 30.08 18.5388C27.6706 18.0597 26.5584 16.669 26.52 14.3489C26.5189 14.2799 26.5741 14.2232 26.6428 14.2232H31.1646C31.2337 14.2232 31.2898 14.2794 31.2898 14.3488V16.3033C31.2898 16.3726 31.3459 16.4289 31.4151 16.4289H34.0079C34.077 16.4289 34.1331 16.4851 34.1331 16.5545V18.6313C34.1331 18.7006 34.077 18.7568 34.0079 18.7568H31.4151C31.3459 18.7568 31.2898 18.8131 31.2898 18.8824V21.1211C31.2898 21.9121 31.7735 22.1728 32.4166 22.1728C33.4245 22.1728 34.4187 21.7175 34.8174 21.5111C34.9009 21.468 35 21.5287 35 21.6228V25.1079C35 25.2009 34.9488 25.2865 34.8666 25.3299C34.473 25.5375 33.2559 26.1131 31.8637 26.1131C29.0004 26.1134 26.8546 24.943 26.8546 21.6579ZM20.9683 25.8084V18.8822C20.9683 18.8128 21.0244 18.7566 21.0936 18.7566H25.2783C25.3475 18.7566 25.4036 18.8128 25.4036 18.8822V25.8084C25.4036 25.8778 25.3475 25.934 25.2783 25.934H21.0936C21.0244 25.934 20.9683 25.8779 20.9683 25.8084ZM20.7314 16.0214C20.7314 17.2003 21.5617 18.156 23.157 18.156C24.7523 18.156 25.5826 17.2003 25.5826 16.0214C25.5826 14.8425 24.7521 13.8867 23.157 13.8867C21.5617 13.8867 20.7314 14.8425 20.7314 16.0214Z",
					fill: "#1E1E1E"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 51,
					y: 16,
					width: 24,
					height: 8,
					rx: 4,
					fill: "#81C5F3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 83,
					y: 16,
					width: 24,
					height: 8,
					rx: 4,
					fill: "#81C5F3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 115,
					y: 16,
					width: 24,
					height: 8,
					rx: 4,
					fill: "#81C5F3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 147,
					y: 16,
					width: 24,
					height: 8,
					rx: 4,
					fill: "#81C5F3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 267.5,
					y: 15.5,
					width: 25,
					height: 9,
					rx: 4.5,
					stroke: "#63BBF9"
				}),
				/* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#clip1_1893_18385)",
					children: [/* @__PURE__ */ _jsx("rect", {
						x: 8,
						y: 48,
						width: 284,
						height: 62,
						rx: 4,
						fill: "#F7F7F7"
					}), /* @__PURE__ */ _jsx("rect", {
						x: 8,
						y: 118,
						width: 284,
						height: 62,
						rx: 4,
						fill: "#F7F7F7"
					})]
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 299,
			height: 179,
			rx: 9.5,
			stroke: "#BCE1FA"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1893_18385",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 300,
				height: 180,
				rx: 10,
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_1893_18385",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 300,
				height: 140,
				fill: "white",
				transform: "translate(0 40)"
			})
		})] })
	]
});
export default SvgOldnav;
